// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Input, PasswordInput } from '@/ui';
import { Form, FormItem } from '@/components';
import { StyledButton, StyledForgotPassword, StyledTitle } from '../Styled';

// Helpers
import { AuthFieldsNames, TSignInFormValues } from '../../helpers/types';
import { useGetFormValidationRules } from '../../hooks';

interface ILogInForm {
  handleSubmit: (values: TSignInFormValues) => void;
  onForgotPassword: () => void;
  isLoading: boolean;
}

const LogInForm = ({ handleSubmit, isLoading, onForgotPassword }: ILogInForm) => {
  const { t } = useTranslation(['auth', 'common']);

  const validationRules = useGetFormValidationRules();

  const placeholder = t('common_placeholder_input', { ns: 'common' });

  return (
    <>
      <StyledTitle>{t('auth_log_in_title')}</StyledTitle>

      <Form onFinish={handleSubmit}>
        <FormItem
          name={AuthFieldsNames.EMAIL}
          rules={validationRules[AuthFieldsNames.EMAIL]}
          label={t('auth_email_label')}
        >
          <Input placeholder={placeholder} type="email" />
        </FormItem>

        <FormItem name={AuthFieldsNames.PASSWORD} label={t('auth_password_label')}>
          <PasswordInput placeholder={placeholder} />
        </FormItem>

        <StyledForgotPassword onClick={onForgotPassword}>{t('forgot_password')}</StyledForgotPassword>

        <StyledButton type="primary" htmlType="submit" loading={isLoading}>
          {t('auth_log_in')}
        </StyledButton>
      </Form>
    </>
  );
};

export default LogInForm;
